import CookieConsentBanner from "@/components/consent/CookieConsentBanner";
import CookiePreferencesDialog from "@/components/consent/CookiePreferencesDialog";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export default function CookieConsentController() {
  const {
    preferences,
    showBanner,
    showDialog,
    openDialog,
    closeDialog,
    acceptAll,
    rejectOptional,
    saveChoices,
  } = useCookieConsent();

  return (
    <>
      {showBanner ? (
        <CookieConsentBanner onAcceptAll={acceptAll} onCustomize={openDialog} onRejectOptional={rejectOptional} />
      ) : null}
      <CookiePreferencesDialog
        onAcceptAll={acceptAll}
        onOpenChange={(open) => (open ? openDialog() : closeDialog())}
        onRejectOptional={rejectOptional}
        onSaveChoices={saveChoices}
        open={showDialog}
        preferences={preferences}
      />
    </>
  );
}
